import { render } from "./SupportConsentCard.vue?vue&type=template&id=d0494f88&scoped=true"
import script from "./SupportConsentCard.vue?vue&type=script&lang=js"
export * from "./SupportConsentCard.vue?vue&type=script&lang=js"

import "./SupportConsentCard.vue?vue&type=style&index=0&id=d0494f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0494f88"]])

export default __exports__